// 新聞頁面 - 手機版社群分享
import { useState, useEffect } from 'react';
import useCopy from '@/hook/useCopy';
import newsClient from '@/common/apiClient/newsClient';

import Image from 'next/image';
import { SHARE_LINK } from '@/common/constant';

const NewsMobileShare = ({ showShare, setShowShare, newsId }) => {
    const copy = useCopy();

    // 當前路徑
    const [currentPath, setCurrentPath] = useState('');

    // 分享
    const onShare = async (media) => {
        try {
            await newsClient.shareNews({ newsId, media });
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') setCurrentPath(window.location.href);
    }, []);

    return (
        <>
            <div
                className={`trans absolute z-[1] right-[30px] ${
                    showShare ? 'bottom-[80px]' : 'bottom-[-300px]'
                } !border-0 duration-500`}
            >
                <div
                    className="flex flex-col gap-y-[16px] [&>*]:img-box [&>*]:w-[42px] [&>*]:h-[42px] [&>*]:relative
                [&_img]:rounded-[50%] [&_img]:border-1 [&_img]:border-white [&_img]:absolute [&_img]:top-0"
                >
                    {SHARE_LINK.map((link, i) => {
                        // 複製連結
                        if (link.title === 'copy')
                            return (
                                <button
                                    onClick={() => {
                                        copy(currentPath);
                                        onShare('copy');
                                    }}
                                    key={'news-share' + i + link.title}
                                >
                                    <Image
                                        width={42}
                                        height={42}
                                        src={`/images/social/icon_share_${link.title}.svg`}
                                        alt="icon"
                                    />
                                </button>
                            );

                        // 跳轉連結
                        return (
                            <a
                                key={'news-share' + i + link.title}
                                href={link.link + currentPath}
                                target="_blank"
                                rel="noreferrer noopener"
                                onClick={() => onShare(link.title)}
                            >
                                <Image
                                    width={42}
                                    height={42}
                                    src={`/images/social/icon_share_${link.title}.svg`}
                                    alt="icon"
                                />
                            </a>
                        );
                    })}
                </div>
            </div>

            {/* 關閉用背景 */}
            {showShare && (
                <div
                    className="w-screen h-screen z-[0] top-0 left-0 fixed"
                    onClick={() => setShowShare(false)}
                />
            )}
        </>
    );
};

export default NewsMobileShare;
